export default __webpack_public_path__ + "static/media/orange-drop.09243561.svg";